import { useRef, useState, useEffect } from 'react';

const useVideoControls = (videoSrc) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1); // Volume range from 0 to 1
  const [progress, setProgress] = useState(0);

  const togglePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const unmute = () => {
    if (videoRef.current) {
      videoRef.current.muted = false; // Set muted to false
    }
  }
  const mute = () => {
    if (videoRef.current) {
      videoRef.current.muted = false; // Set muted to false
    }
  }

  const handleVolumeChange = (newVolume) => {
    setVolume(newVolume);
    if (videoRef.current) {
      videoRef.current.volume = newVolume;
    }
  };

  const handleProgressChange = (newProgress) => {
    if (videoRef.current) {
      const newTime = (newProgress / 100) * videoRef.current.duration;
      videoRef.current.currentTime = newTime;
      setProgress(newProgress);
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const currentProgress = (videoRef.current.currentTime / videoRef.current.duration) * 100;
      setProgress(currentProgress);
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener('timeupdate', handleTimeUpdate);
      return () => {
        videoElement.removeEventListener('timeupdate', handleTimeUpdate);
      };
    }
  }, []);

  return {
    videoRef,
    isPlaying,
    setIsPlaying,
    volume,
    progress,
    unmute,
    mute,
    togglePlayPause,
    handleVolumeChange,
    handleProgressChange,
    videoSrc,
  };
};

export default useVideoControls;